import React from 'react'
import './skills.css'
import data from '../../data.js'
import Skillcards from './skillscards.jsx'


const SkillsBars = () => {    
  return (
    <div className="skillCards">
    {data.map((item, index)=>{          
      return <Skillcards 
        key={item.id || index}
        img={item.img}
        alt={item.alt || item.name}
        name={item.name}
        content={item.content}/>
      })}
    </div>
  )
}

export default SkillsBars